import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { fetchStorageDetailsReport } from "../../../store/actions/reportsActions";
import DetailsControls from "./DetailsControls";

import styles from "./styles";

const useStyles = makeStyles(styles);

const StorageDetailsFilterForm = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleSubmit = (event) => {
    event.preventDefault();

    dispatch(fetchStorageDetailsReport());
  };

  return (
    <form className={classes.form} onSubmit={handleSubmit} noValidate data-testid="storage_details_filter_form">
      <DetailsControls handleSubmit={handleSubmit} />
    </form>
  );
};

export default StorageDetailsFilterForm;
